import { render, staticRenderFns } from "./AttributeSeparation.vue?vue&type=template&id=fde5f2f6"
import script from "./AttributeSeparation.vue?vue&type=script&lang=js"
export * from "./AttributeSeparation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports